export default {
  data () {
    return {
      oauth: {
        all: null,
        inMin: null
      }
    }
  },
  methods: {
      fetchPendingOrders() {
        return this.$http.get(api+'api/v1/order/stats')
      }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/transactions.js